import React, { forwardRef, useState } from 'react'
import { motion } from 'framer-motion'
import logo from '../../Assets/Images/logo.png'
import { useSelector } from "react-redux"
import RasiKattam from "../../Components/RasiKattam"
import AmsaKattam from "../../Components/AmsaKattam"
import { FLAW_TAMIL_MAP, STAR_TAMIL_MAP } from './CreateUser'

const tMaritalStatus = [{ text: 'முதல் திருமணம்', value: 'Never Married' }, { text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' },{text:"பிரிந்தனர்",value:'seperated'}]
const eMaritalStatus = [{ text: 'Never Married', value: 'Never Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widow', value: 'Widow' }, { text: 'Widower', value: 'Widower' },{text:"Separated",value:'seperated'}]

// Labels: Tamil vs English
const LABELS = {
    tamil: {
        brandTagline: 'கள்ளர் திருமண சேவை',
        companyName: 'ராயல் காவேரி திருமண சேவை',
        companyCity: 'தஞ்சாவூர்',
        refId: 'பதிவு எண்',
        name: 'பெயர்',
        fatherName: 'தந்தை பெயர்',
        motherName: 'தாய் பெயர்',
        education: 'படிப்பு',
        occupation: 'தொழில்',
        income: 'வருமானம்',
        ageHeight: 'வயது/உயரம்',
        height: 'உயரம்',
        weight: 'எடை',
        complexion: 'நிறம்',
        siblings: 'உடன் பிறந்தவர்கள்',
        male: 'ஆண்',
        female: 'பெண்',
        address: 'தொடர்பு முகவரி',
        mobile: 'அலைபேசி எண்',
        whatsapp: 'வாட்ஸ்அப்',
        marital: 'திருமண நிலை',
        religion: 'மதம்',
        caste: 'சாதி',
        flaws: 'தோஷங்கள்',
        assets: 'சொத்து தகவல்',
        horoscope: 'ஜாதக விவரம்',
        tamilYear: 'தமிழ் வருடம்',
        tamilMonth: 'தமிழ் மாதம்',
        tamilDate: 'தமிழ் தேதி',
        day: 'கிழமை',
        star: 'நட்சத்திரம்',
        zodiac: 'இராசி',
        birthPlace: 'பிறந்த ஊர்',
        birthTime: 'பிறந்த நேரம்',
        dob: 'பிறந்த தேதி',
        thisai: 'திசை இருப்பு',
        year: 'வருடம்',
        month: 'மாதம்',
        date: 'நாள்',
        year_suffix: 'ஆண்டு',
        month_suffix: 'மாதம்',
    },
    english: {
        brandTagline: 'Kallar thirumana sevai',
        companyName: 'Royal kavery matrimony',
        companyCity: 'Thanjavur',
        refId: 'Reg. No.',
        name: 'Name',
        fatherName: "Father's Name",
        motherName: "Mother's Name",
        education: 'Education',
        occupation: 'Occupation',
        income: 'Income',
        ageHeight: 'Age / Height',
        height: 'Height',
        weight: 'Weight',
        complexion: 'Complexion',
        siblings: 'Siblings',
        male: 'Male',
        female: 'Female',
        address: 'Contact Address',
        mobile: 'Mobile Number',
        whatsapp: 'WhatsApp',
        marital: 'Marital Status',
        religion: 'Religion',
        caste: 'Caste',
        flaws: 'Flaws',
        assets: 'Assets',
        horoscope: 'Horoscope Details',
        tamilYear: 'Tamil Year',
        tamilMonth: 'Tamil Month',
        tamilDate: 'Tamil Date',
        day: 'Day',
        star: 'Star',
        zodiac: 'Zodiac Sign',
        birthPlace: 'Birth Place',
        birthTime: 'Birth Time',
        dob: 'Date of Birth',
        thisai: 'Dasa Balance',
        year: 'Year',
        month: 'Month',
        date: 'Date',
        year_suffix: 'Year',
        month_suffix: 'Month',
    }
}

const PrintUser = ({ userDetails, lang: langProp }) => {
    const [lang, setLang] = useState(langProp || 'tamil')

    // Keep internal state in sync if the parent changes the prop
    // (e.g. user clicks தமிழ்/EN toggle on the preview page before printing)
    React.useEffect(() => {
        if (langProp) setLang(langProp)
    }, [langProp])

    const L = LABELS[lang]
    const maritalList = lang === 'tamil' ? tMaritalStatus : eMaritalStatus

    const educationList = useSelector((state) => state.auth.educationList)
    const zodiacSigns = useSelector((state) => state.auth.zodiacSigns)
    const flaws = useSelector((state) => state.auth.flaws)
    const occupation = useSelector((state) => state.auth.fullOccupations)
    const allStars = useSelector((state) => state.auth.allStars)
    const status = useSelector((state) => state.auth.status)
    const tStatus = useSelector((state) => state.auth.tStatus)
    const tFlaws = useSelector((state) => state.auth.tFlaws)
    const tOccupation = useSelector((state) => state.auth.tOccupation)
    const dhisas = useSelector((state) => state.auth.tDhisa)

    const getQualification = (value) => {
        const education = educationList.find((x) => x.value === value)?.text
        return education ? education.split('-')[0] : '---'
    }

    const calculateAge = (birthdate) => {
        if (!birthdate) return '---'
        const today = new Date();
        const birthDate = new Date(birthdate);
        if (Number.isNaN(birthDate.getTime())) return '---'
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const formatDisplayDate = (value) => {
        if (!value || typeof value !== 'string') return '---'
        const parts = value.split('-')
        if (parts.length !== 3) return value
        return `${parts[2]}/${parts[1]}/${parts[0]}`
    }

    const getFlaws = (value) => {
        if (lang === 'tamil') {
            return FLAW_TAMIL_MAP[value] || tFlaws?.find((x) => x.value === value)?.text || value || '---'
        }
        return flaws?.find((x) => x.value === value)?.text || value || '---'
    }

    const getStatus = (value) => {
        return tStatus?.find((x) => x.value === value)?.text || '---'
    }

    const getZodiac = (value) => {
        return zodiacSigns?.filter((x) => { return x?.value === value })[0]?.text
    }

    const getStars = (value) => {
        const fromRedux = allStars.find((x) => x.value === value)?.text
        if (fromRedux) return lang === 'tamil' ? (STAR_TAMIL_MAP[fromRedux] || fromRedux) : fromRedux
        // value is already a plain star name (from static map)
        return lang === 'tamil' ? (STAR_TAMIL_MAP[value] || value) : value
    }

    const getDhisas = (values) => {
        return values ? dhisas?.find((x) => x.value === parseInt(values))?.text || '---' : '---'
    }

    return (
        <motion.div className="border border-primeColor flex flex-col w-full relative">
            {/* Language toggle — screen only, not printed */}
            <div className="no-print flex items-center gap-2 px-4 py-2 bg-slate-50 border-b border-borderColor">
                <span className="text-xs font-bold uppercase tracking-[0.14em] text-tpColor">Print Language:</span>
                <div className="inline-flex rounded-full border border-borderColor bg-white p-0.5 text-xs font-bold">
                    <button type="button" onClick={() => setLang('tamil')} className={`rounded-full px-3 py-1 transition ${lang === 'tamil' ? 'bg-primeColor text-white' : 'text-tColor hover:bg-lightGrey/50'}`}>தமிழ்</button>
                    <button type="button" onClick={() => setLang('english')} className={`rounded-full px-3 py-1 transition ${lang === 'english' ? 'bg-primeColor text-white' : 'text-tColor hover:bg-lightGrey/50'}`}>English</button>
                </div>
            </div>

            <motion.div className="flex flex-row justify-between px-10 py-1 w-full">
                <motion.div className="flex flex-col justify-between h-fit">
                    <motion.div className="flex flex-col">
                        <motion.div className="bg-primeColor justify-center w-full text-center items-center flex flex-row h-fit px-2 py-2">
                            <img src={logo} height={70} width={70} />
                        </motion.div>
                        <p className="w-full flex flex-row justify-center items-center py-2">{L.brandTagline}</p>
                    </motion.div>
                    <p className="text-2xl text-primeColor font-bold">www.royalkavery.com</p>
                </motion.div>

                <motion.div className="flex flex-col py-5">
                    <p>{L.companyName}</p>
                    <p>{L.companyCity}</p>
                </motion.div>
            </motion.div>
            <motion.div className="h-1 w-full bg-primeColor" />
            <motion.div className='flex flex-row h-full w-full'>
                <motion.div className="flex flex-col gap-1 w-4/6 px-5 py-2">
                    <motion.div className="flex flex-row justify-between w-full">
                        <p className="font-bold text-sm w-2/4">{L.refId}</p>
                        <p className="text-sm w-2/4">- {userDetails?.refId}</p>
                    </motion.div>
                    <motion.div className="flex flex-row justify-between w-full">
                        <p className="font-bold w-2/4 text-sm">{L.name}</p>
                        <p className="justify-start w-2/4 text-sm">- {
                            lang === 'tamil'
                              ? [userDetails?.tFirstName || userDetails?.firstName, userDetails?.tLastName || userDetails?.lastName, userDetails?.tSurname || userDetails?.surname].filter(Boolean).join(' ')
                              : [userDetails?.firstName, userDetails?.lastName, userDetails?.surname].filter(Boolean).join(' ')
                          }</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.fatherName}</p>
                        <p className="text-sm  w-2/4 flex flex-row">- {userDetails?.familyInformation?.fatherFirstName} / {userDetails?.familyInformation?.fatherSurname} / {userDetails?.familyInformation?.fatherNative}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.motherName}</p>
                        <p className="text-sm flex w-2/4 flex-row">- {userDetails?.familyInformation?.motherFirstName} / {userDetails?.familyInformation?.motherSurname} / {userDetails?.familyInformation?.motherNative}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.marital}</p>
                        <p className="text-sm w-2/4">- {maritalList.find(x => x.value === (userDetails?.maritalStatus || userDetails?.additionalInformation?.maritalStatus))?.text || userDetails?.maritalStatus || userDetails?.additionalInformation?.maritalStatus || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.religion}</p>
                        <p className="text-sm w-2/4">- {userDetails?.religion || userDetails?.additionalInformation?.religion || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.caste}</p>
                        <p className="text-sm w-2/4">- {[userDetails?.caste || userDetails?.additionalInformation?.caste, userDetails?.subCaste || userDetails?.additionalInformation?.subCaste].filter(Boolean).join(' / ') || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.education}</p>
                        <p className="text-sm w-2/4 flex-wrap">- {userDetails?.otherEducationalQualification || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.occupation}</p>
                        <p className="text-sm w-2/4">- {userDetails?.occupationDetail || userDetails?.occupation || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.income}</p>
                        <p className="text-sm w-2/4">- {userDetails?.salary ? userDetails.salary + ' / ' + (userDetails?.salaryMode === 'year' ? L.year_suffix : L.month_suffix) : '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.ageHeight}</p>
                        <p className="text-sm w-2/4">- {calculateAge(userDetails?.dateOfBirth)} / {userDetails?.heightInFeet || userDetails?.height || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.weight} / {L.complexion}</p>
                        <p className="text-sm w-2/4">- {[userDetails?.weight ? userDetails.weight + ' kg' : null, userDetails?.complexion].filter(Boolean).join(' / ') || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.siblings}</p>
                        <p className="text-sm flex flex-row w-2/4">- <span className='font-bold'>{L.male}&nbsp;{userDetails?.familyInformation?.numberOfMaleSiblings ?? userDetails?.familyInformation?.numberOfMaleSibilings ?? '--'}</span>&nbsp;<span className='font-bold'>{L.female}&nbsp;{userDetails?.familyInformation?.numberOfFemaleSiblings ?? userDetails?.familyInformation?.numberOfFemaleSibilings ?? '--'}</span></p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.flaws}</p>
                        <p className="text-sm w-2/4">- {userDetails?.additionalInformation?.flaws?.length ? userDetails.additionalInformation.flaws.map(f => getFlaws(f)).join(', ') : '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.assets}</p>
                        <p className="text-sm w-2/4">- {userDetails?.familyInformation?.assetInfo || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-full text-sm">{L.address}</p>
                        <p className="text-sm flex flex-row w-2/4">
                            {userDetails?.contactInformation?.presentAddress
                                ? '- ' + [
                                    userDetails.contactInformation.presentAddress.addressLine1,
                                    userDetails.contactInformation.presentAddress.addressLine2,
                                    userDetails.contactInformation.presentAddress.city,
                                    userDetails.contactInformation.presentAddress.district,
                                    userDetails.contactInformation.presentAddress.state,
                                    userDetails.contactInformation.presentAddress.pinCode,
                                  ].filter(Boolean).join(', ')
                                : '--'}
                        </p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.mobile}</p>
                        <p className="text-sm flex flex-row w-2/4">- {userDetails?.contactInformation?.mobileNumber || userDetails?.mobileNumber || '--'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">{L.whatsapp}</p>
                        <p className="text-sm w-2/4">- {Array.isArray(userDetails?.contactInformation?.whatsappNumber) ? userDetails.contactInformation.whatsappNumber.join(', ') : (userDetails?.contactInformation?.whatsappNumber || '--')}</p>
                    </motion.div>
                </motion.div>
                <motion.div className='flex flex-col items-center w-2/6 py-2 gap-2'>
                    <motion.div className='h-48 w-48'>
                        {userDetails?.images && userDetails.images.filter(i => i?.imageUrl)[0] && (
                            <img
                                src={userDetails.images.filter(i => i?.imageUrl)[0].imageUrl}
                                className="h-48 w-48 object-cover rounded-lg"
                                alt="Profile"
                            />
                        )}
                    </motion.div>
                </motion.div>
            </motion.div>
            <motion.div className="w-full flex flex-col items-center justify-center">
                <p className="w-fit px-2 py-1 rounded-full text-sm ring ring-1 ring-black">{L.horoscope}</p>
            <motion.div className="flex flex-wrap flex-row w-full px-5 py-2 gap-3 justify-center">
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.tamilYear}:</p>
                    <p className="text-sm">{userDetails?.tamilYear || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.tamilMonth}:</p>
                    <p className="text-sm">{userDetails?.tamilMonth || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.tamilDate}:</p>
                    <p className="text-sm">{userDetails?.tamilDate || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.day}:</p>
                    <p className="text-sm">{userDetails?.birthDay || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.star}:</p>
                    <p className="text-sm">{userDetails?.additionalInformation?.star ? getStars(userDetails?.additionalInformation?.star) || '---' : '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.zodiac}:</p>
                    <p className="text-sm">{userDetails?.additionalInformation?.zodiacSign ? getZodiac(userDetails?.additionalInformation?.zodiacSign) || '---' : '----'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.birthPlace}:</p>
                    <p className="text-sm">{userDetails?.birthPlace || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.dob}:</p>
                    <p className="text-sm">{formatDisplayDate(userDetails?.dateOfBirth)}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.birthTime}:</p>
                    <p className="text-sm">{userDetails?.birthTime || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm">{userDetails?.thisaiIruppu ? getDhisas(userDetails?.thisaiIruppu) || '---' : '---'}</p>
                    <p className="text-sm font-bold">{L.thisai}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">{L.year}</p>
                    <p className="text-sm">{userDetails?.thisaiIruppuYear || '---'}</p>
                    <p className="text-sm font-bold">{L.month}</p>
                    <p className="text-sm">{userDetails?.thisaiIruppuMonth || '---'}</p>
                    <p className="text-sm font-bold">{L.date}</p>
                    <p className="text-sm">{userDetails?.thisaiIruppuDate || '---'}</p>
                </motion.div>
            </motion.div>
            <motion.div className="flex flex-row w-full py-2 justify-around px-5 gap-1">
                <RasiKattam kattamOuterInjectClass={`h-[280px] w-[280px]`} kattamInnerInjectclass={'h-[70px] w-[70px]'} readOnly={true} rasiValues={userDetails?.rasiKattam?.rasiPlanets} />
                <AmsaKattam kattamOuterInjectClass={`h-[280px] w-[280px]`} kattamInnerInjectclass={'h-[70px] w-[70px]'} readOnly={true} amsaValues={userDetails?.amsaKattam?.amsaPlanets} />
            </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default PrintUser
